import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePreorderEnabled } from '../../hooks/usePreorderEnabled';
import Settings from './Settings';

const SettingsGuard: React.FC = () => {
  const { enabledNewVersion } = usePreorderEnabled();

  if (enabledNewVersion) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Settings />;
};

export default SettingsGuard;
